module.exports = __webpack_public_path__ + "media/images/top/qa/ogp-676259f079d5ffdc11a72cfbfaff8f60.png";